import * as z from "zod";
import { schemaFormEvent } from "../../../features/forms/schemas/schemaFormEvent";
import { schemaFormAction } from "../../../features/forms/schemas/schemaFormAction";

const schemas = {
  ...schemaFormEvent.shape,
  ...schemaFormAction.shape,
};

export const isRequired = (field: keyof typeof schemas): boolean => {
  const fieldSchema = schemas[field];

  if (!fieldSchema) return false;
  if (!(fieldSchema instanceof z.ZodString)) return false;

  return (
    fieldSchema._def.checks?.some((check) => check.kind === "min") ?? false
  );
};
export const getLabel = (
  label: string,
  field: keyof typeof schemas,
): string | JSX.Element => {
  const isFieldRequired = isRequired(field);
  return isFieldRequired ? (
    <>
      {label} <span style={{ color: "red" }}>*</span>
    </>
  ) : (
    label
  );
};
